import { useCallback } from 'react';

import { useSelector } from 'react-redux';

import { StreamTypes } from 'store/player/actions.types';
import {
    selectAppSessionId,
    selectVideoSessionId,
} from 'store/session/selectors';

import { RailSelectionUavParams, UavEvents } from './types';
import useGetBaseUavParams from './useGetBaseUavParams';
import { getPlayBackType } from './utils';

export default function useGetRailSelectionParams() {
    const appSessionId = useSelector(selectAppSessionId);
    const genericVideoSessionId = useSelector(selectVideoSessionId);

    const getBaseUavParams = useGetBaseUavParams();

    const getRailSelectionParams = useCallback(
        (
            templateId: string,
            railId: string,
            depth: number,
            editorialId?: string,
            contentType?: StreamTypes,
        ): RailSelectionUavParams | undefined => {
            const baseUavParams = getBaseUavParams(UavEvents.RAIL_SELECTION);

            if (baseUavParams) {
                return {
                    ...baseUavParams,
                    metadata: {
                        railId,
                        templateId,
                        editorialID: editorialId,
                        appSessionId,
                        depth: `${depth + 1}`,
                        contentType: getPlayBackType(contentType),
                        playbackSessionId: genericVideoSessionId,
                        ...baseUavParams.metadata,
                    },
                };
            }

            return undefined;
        },
        [getBaseUavParams, appSessionId, genericVideoSessionId],
    );

    return {
        getRailSelectionParams,
    };
}
